import { QtmButton, QtmIcon } from '@qtm/react';
import { useRemoveUserMutation } from 'api/UsersEndPoints';
import { useState } from 'react';

type Props = {
  ids: number[];
};

const DeleteUserSelectionBtn = ({ ids }: Props) => {
  const [removeUser] = useRemoveUserMutation();

  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    const requests = ids.map(id => removeUser(id).unwrap());
    await Promise.all(requests);
    setLoading(false);
  };

  return (
    <QtmButton color="danger" variant="outline" onClick={onClick} disabled={loading}>
      <QtmIcon icon="delete" />
      <span>Delete</span>
    </QtmButton>
  );
};

export default DeleteUserSelectionBtn;
